import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next';
interface InvalidFeedbackProps {
    error: any;
    className?: any;
}

function InvalidFeedback({ error, className = '' }: InvalidFeedbackProps) {

    const { t } =useTranslation();
    
    const getType = useCallback(() => {
        switch (error?.type) {
            case 'required':
                return `${t("components.invalid-feedback.required-field-error")}`
            case 'maxLength':
                // return `Sólo se permiten máximo ${error.message} caracteres`
                return t('components.invalid-feedback.maxlength', { message: error.message })
            case 'minLength':
                // return `Se require un mínimo de ${error.message} caracteres`
                return t('components.invalid-feedback.minlength', { message: error.message })
            case 'min':
                return `${error.message}`
            case 'max':
                return `${error.message}`
            case 'pattern':
            case 'custom':
                return `${error.message}`
        
            default:
                return error?.type
                // return `${t("components.invalid-feedback.required-field-error")}`
        }
    }, [error?.type])

    return error ? <span className={`invalid-feedback ${className}`}>{getType()}</span> : <></>
}

export default InvalidFeedback